const ConstsEnum = Object.freeze({
    campoObrigatorio: 'Campo obrigatório'
})

export default ConstsEnum;
